export class ErrorPageError extends Error {
    constructor(
        public cause: Error,
        public message: string,
    ) {
        super(message);
        this.name = "ErrorPageError";
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
